//letters: ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
//uppercase:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','W','Y','Z'],
// numbers: ['0','1','2','3','4','5','6','7','8','9'],

//symbols: ['!','@','#','$','%','^','&','*','`','~','/','=','?','+','|','_','-',':',';','.',','],

export default class Generator {
  getRandomInt(min, max) {
    //включая min  и не включая max
    return Math.floor(Math.random() * (max - min)) + min;
  }
  PassSymvol = {
    letters: [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ],
    uppercase: [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "W",
      "Y",
      "Z"
    ],
    numbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    symbols: [
      "!",
      "@",
      "#",
      "$",
      "%",
      "^",
      "&",
      "*",
      "`",
      "~",
      "/",
      "=",
      "?",
      "+",
      "|",
      "_",
      "-",
      ":",
      ";",
      ".",
      ","
    ]
  };
  getNew = (i, leters, uppercase, numbers, symbols) => {
    let passstring = [];
    let leterstring = leters ? this.PassSymvol.letters : [];
    let upperstring = uppercase ? this.PassSymvol.uppercase : [];
    let numberstring = numbers ? this.PassSymvol.numbers : [];
    let symbolsstring = symbols ? this.PassSymvol.symbols : [];
    passstring = [
      ...leterstring,
      ...upperstring,
      ...numberstring,
      ...symbolsstring
    ];
    const passstringLength = passstring.length;
    let passArr = [];
    for (let j = 0; j < i; j++) {
      let rand = this.getRandomInt(0, passstringLength);
      passArr.push(passstring[rand]);
    }
    return passArr.join("");
  };
  getSimvolArr = j => {
    let sw = this.getRandomInt(0, 4);
    switch (sw) {
      case 0:
        return this.getRandomInt(33, 48);
        break;
      case 1:
        return this.getRandomInt(58, 65);
        break;
      case 2:
        return this.getRandomInt(91, 97);
        break;
      case 3:
        return this.getRandomInt(123, 127);
        break;
      default:
        break;
    }
  };

  getLowCaseArr = j => {
    return this.getRandomInt(97, 123);
  };
  getUpperCaseArr = j => {
    return this.getRandomInt(65, 91);
  };
  getNumArr = j => {
    return this.getRandomInt(48, 57);
  };
  getArr(i, f1 = null, f2 = null, f3 = null, f4 = null) {
    let func = [];
    let arr = [];
    for (let i in arguments) {
      if (typeof arguments[i] == "function") {
        func.push(arguments[i]);
      }
    }
    let rand;
    for (let j = 0; j < i; j++) {
      if (func.length == 1) {
        rand = 0;
      } else {
        rand = this.getRandomInt(0, func.length);
      }
      console.log(j);
      arr.push(func[rand]());
    }
    return arr;
  }

  getPass = arr => {
    return arr.map(i => String.fromCharCode(i)).join("");
  };
}
